import type { UserInfo } from '@com/type/user.type'

// 线上域名 playturbo.com
// 通过字符串拼接的方式，避免被gulp的域名替换命中
export const mindworksCreative = ['playturbo', 'com'].join('.')

/**
 * 判断是否为国内ip
 */
export function isChinaIp(cc: UserInfo['cc']): boolean {
  return cc === 'CN'
}

export default function redirect2cn(cc?: UserInfo['cc']): void {
  // 获取当前的 URL
  const currentUrl: string = window.location.href

  // 创建一个 URL 对象
  const url: URL = new URL(currentUrl)

  // 通过字符串拼接的方式，避免被gulp的域名替换命中
  const hackUrl = mindworksCreative

  // 检查当前域名是否为 playturbo.com
  // 如果cc有值，则检查是否为CN
  if (
    url.hostname.endsWith(hackUrl) &&
    (typeof cc === 'undefined' || isChinaIp(cc))
  ) {
    // 替换域名为 playturbo.cn
    const newHostname: string = url.hostname.replace(hackUrl, 'playturbo.cn')

    // 构建新的 URL
    const newUrl = `${url.protocol}//${newHostname}${url.pathname}${url.search}${url.hash}`

    // 跳转到新的 URL
    window.location.href = newUrl
  }
}
